import { Accordion } from '@/components/AccordionSideMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  BackButton,
  BigContent,
  Item,
  PromotionalSideOffers,
  SmallContent,
} from '@/components/NewHeader/SideMenu/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';
import { useState } from 'react';

export function VillasInPuglia() {
  const {
    newHeader: { villasInPuglia, nav },
  } = useTranslation();
  const { puglia } = usePromotionalCatalogs();
  const [value, setValue] = useState(villasInPuglia.byDestination.title);

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'villas-in-puglia')?.title ||
    'Villas in Puglia';
  const offersTitle =
    nav.find((item) => item.id === 'offers')?.title || 'Offers';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <>
      <BackButton />

      <Accordion
        type="single"
        collapsible
        className="w-full bg-black/5"
        value={value}
        onValueChange={setValue}>
        <Item
          value={villasInPuglia.byDestination.title}
          isOpen={value === villasInPuglia.byDestination.title}>
          <BigContent
            onItemClick={handleItemClick}
            items={villasInPuglia.byDestination.items}
          />
        </Item>
        <Item
          value={villasInPuglia.byArea.title}
          isOpen={value === villasInPuglia.byArea.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={villasInPuglia.byArea.items}
          />
        </Item>
        <Item
          value={villasInPuglia.byType.title}
          isOpen={value === villasInPuglia.byType.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={villasInPuglia.byType.items}
          />
        </Item>
      </Accordion>

      <PromotionalSideOffers
        title={offersTitle}
        items={puglia}
        onItemClick={handleItemClick}
      />

      <div className="p-4">
        <CtaLink
          onClick={() =>
            sendMenuClickEvent({
              section,
              sectionItem: villasInPuglia.cta.title,
            })
          }
          href={villasInPuglia.cta.href}>
          {villasInPuglia.cta.title}
        </CtaLink>
      </div>
    </>
  );
}
